// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"9aab3bc6","315":"f739d6bf","453":"12dba228","549":"d2abfa17","597":"c2ef772c","854":"530f9be6"}[chunkId] + ".chunk.js";
};